export default {
  Sms: 'SMS',
  Email: 'Email',
  Push: 'Push',
  Webhook: 'Webhook',
};



// WEBPACK FOOTER //
// ./src/models/AlertsChannels.js